import Pregunta from "./components/Pregunta";
import React ,{useState} from 'react';
import Formulario from "./components/Formulario";
import Listado from "./components/Listado";
import ControlPresupuesto from "./components/ControlPresupuesto";



function App() {

 

  //useEffect


  //DEFINIR STATE
  const [presupuesto, guardarPresupuesto] = useState(0);
  const [restante, guardarRestante] = useState(0);
  const [pregunta, actualizarPregunta] = useState(true);
  const [Gastos, setGastos] = useState([]);

  //Cuando agreguemos un nuevo gasto

  const agregarNuevoGasto = gasto =>{

   

    setGastos ([

      ...Gastos,
      gasto
    ])

  }


  return (
    <div className="container">
      <header>  <h1>Gasto Semanal</h1></header>


      <div className="contenido-principal contenido">
        {pregunta ? (
           <Pregunta
           guardarPresupuesto = {guardarPresupuesto}
           guardarRestante = {guardarRestante}
           actualizarPregunta = {actualizarPregunta}
 
           />

        ):
        
        (
          <div className="row">
          <div className="one-half column">
            <Formulario
            agregarNuevoGasto = {agregarNuevoGasto}
            guardarRestante = {guardarRestante}
            restante = {restante}
            />
          </div>


          <div className="one-half column">
             <Listado
              Gastos = {Gastos}
             />

             <ControlPresupuesto
             restante = {restante}
             presupuesto = {presupuesto}
              />
          </div>
        </div>


        )}

       

        




      </div>
 
      
    </div>
  );
}

export default App;
